<template>
	<div id="app">
		<el-container>
			<el-header>
				<div class="logo">
					<img src="./assets/img/toplogo.png" alt />
				</div>
				<el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" @select="handleSelect"
					:router="router">
					<el-menu-item index="/">首页</el-menu-item>
					<el-menu-item index="/about">走进锐恩</el-menu-item>
				</el-menu>
			</el-header>
			<el-main>
				<router-view />
			</el-main>
			<div class="footer">
				<p>深圳锐恩控股集团有限公司</p>
				<p>ICP证: <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2023132651号-4</a></p>
			</div>
		</el-container>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				router: true,
				defaultActive: "/",
				isShow: false
			};
		},
		methods: {
			handleSelect(key) {
				this.isShow = this.defaultActive != key;
				window.console.log(this.isShow);
			}
		}
	};
</script>

<style>
	* {
		padding: 0;
		margin: 0;
	}

	html,
	body {
		height: 100%;
	}

	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	.el-menu--horizontal>.el-menu-item.is-active {
		border-bottom: 2px solid #FFE100;
	}

	.el-header {
		display: flex;
		justify-content: space-between;
		align-content: center;
		width: 1240px;
		margin: 0 auto;
		//background-color: #fff;

		.logo {
			width: 211px;
			height: 36px;
			padding: 10px;

			img {
				width: 100%;
				line-height: 60px;
			}
		}
	}

	.el-main {
		padding: 0 !important;
	}

	.footer {
		display: flex;
		flex-direction: column;
		gap: 20rpx;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 14px;
		position: fixed;
		bottom: 50px;
		width: 100vw;
		text-align: center;
		z-index: 100;
	}
</style>